import { BrowserModule } from "@angular/platform-browser";
import {
  DatePipe,
  TitleCasePipe,
} from "@angular/common";
import { NgModule } from "@angular/core";
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ApiService } from "./services/api.service";
import { AuthGuard } from "./authGuard/auth.guard";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Injector } from "@angular/core";
import { NgxSpinnerModule } from "ngx-spinner";
import { UtilitiesService } from "./utilities/utilities.service";
// import { NotifierModule } from "angular-notifier";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { NgxPaginationModule } from "ngx-pagination";
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { AppDialogModule } from "./shared/app-dialog/app-dialog.module";
import { AppInjector } from "./shared/app-injector";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { HttpStateInterceptor } from "./interceptors/http-state.interceptor";

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent], imports: [CommonModule,
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule.forRoot({ type: 'ball-clip-rotate-multiple' }),
    // NotifierModule,
    BsDatepickerModule.forRoot(),
    NgxPaginationModule,
    MatNativeDateModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    AppDialogModule], providers: [
      ApiService,
      AuthGuard,
      UtilitiesService,
      DatePipe,
      TitleCasePipe,
      provideHttpClient(withInterceptorsFromDi()),
      MessageService,
      providePrimeNG({
        theme: {
          preset: Aura
        }
      }),
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: HttpStateInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
    ]
})
export class AppModule {
  constructor(injector: Injector) {
    // Used by compatibility wrappers (e.g., Swal shim)
    AppInjector.set(injector);
  }
}
